import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { api } from "../axios/api";

const PdfViewer = ({ title = "Documento PDF", path, filename = "documento.pdf", onClose }) => {
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let objectUrl = "";
    let disposed = false;

    const load = async () => {
      if (!path) return;
      setLoading(true);
      setError("");

      try {
        const response = await api.get(path, { responseType: "blob" });
        objectUrl = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        if (!disposed) setUrl(objectUrl);
      } catch (err) {
        if (!disposed) setError(err.message || "Nao foi possivel carregar o PDF.");
      } finally {
        if (!disposed) setLoading(false);
      }
    };

    load();

    return () => {
      disposed = true;
      if (objectUrl) window.URL.revokeObjectURL(objectUrl);
    };
  }, [path]);

  if (!path) return null;

  return (
    <div className="pdf-viewer-backdrop">
      <section className="pdf-viewer-panel">
        <header className="pdf-viewer-header">
          <strong>{title}</strong>
          <div className="d-inline-flex gap-2">
            {url && (
              <a className="btn btn-light btn-icon" href={url} download={filename} title="Descarregar PDF">
                <Download size={17} />
              </a>
            )}
            <button className="btn btn-light btn-icon" type="button" onClick={onClose} title="Fechar">
              <X size={17} />
            </button>
          </div>
        </header>
        <div className="pdf-viewer-body">
          {loading && <div className="pdf-viewer-state">A carregar PDF...</div>}
          {error && <div className="pdf-viewer-state text-danger">{error}</div>}
          {url && <iframe title={title} src={url} />}
        </div>
      </section>
    </div>
  );
};

export default PdfViewer;
